
<div class="container" id="product">
    <div class='immersive-logo mt-2 d-none'></div>


    <div class="page-header page-produit mb-4 position-relative">

        <i class="fa fa-chevron-left returnButton" aria-hidden="true" (click)="goBack()"></i>


        <h1 class="pt-5 pb-3">{{ product.name }}</h1>

        <div class="pictos mb-4 text-muted">
            <div class="flex-with-gap">
            <strong *ngIf="!product['produced_with'] && !product['partnerCompany']">{{'Développé avec l\'expertise métier de' | translate}} {{'nos experts HSE en interne' | translate}}</strong>
                <strong *ngIf="!product['produced_with'] && product['partnerCompany']">{{'Développé avec l\'expertise métier de' | translate}} {{product['partnerCompany']}}</strong>
                <strong *ngIf="product['produced_with'] && !product['partnerCompany']">{{'Développé par' | translate}} {{product['produced_with']}}</strong>
                <strong *ngIf="product['produced_with'] && product['partnerCompany']">{{'Développé par' | translate}} {{product['produced_with']}} {{'avec l\'expertise métier de' | translate}} {{product['partnerCompany']}}</strong>
            </div>
            <div class="flex-with-gap" *ngIf="product.duration != '' && product.duration != null">
                <i class="material-icons">timer</i>
                <span>{{product.duration}} min</span>
            </div>
            <div class="flex-with-gap" *ngIf="product['blind'] || product['hear'] || product['touch']">
                <i class="material-icons" *ngIf="product['blind']">remove_red_eye</i>
                <i class="material-icons" *ngIf="product['hear']">hearing</i>
                <i class="material-icons" *ngIf="product['touch']">touch_app</i>
            </div>
        </div>

        <!-- <ul class="mots-cles d-flex container">
            <div class="row ml-0" *ngIf="product && product.prodtags">
                <li [routerLink]="language.navigateAccordingToLang(['/content'])" [queryParams]="{tags: tag.id}" class="d-flex align-self-center mb-2" *ngFor="let tag of product.prodtags">{{tag.name}}</li>
            </div>

        </ul> -->

        <p class="lead text-muted mb-4">{{product.subtitle}}</p>


    </div>
    <div class="row my-3">
        <div class="col-lg-8 mb-5 mb-lg-0">
            <div class="video">
                <iframe *ngIf="carouselShow == 0 && product['video']" [src]="url" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>
                <img *ngIf="carouselShow == 1" [attr.src]="productService.getProductImage(product.preview, isGroup)" alt="Image of the workshop {{product.name}}" title="{{product.name}}" loading="lazy">
                <img *ngIf="carouselShow == 2" [attr.src]="productService.getProductImage(product.screenshot1, isGroup)" alt="Image of the workshop {{product.name}}" title="{{product.name}}" loading="lazy">
                <img *ngIf="carouselShow == 3" [attr.src]="productService.getProductImage(product.screenshot2, isGroup)" alt="Image of the workshop {{product.name}}" title="{{product.name}}" loading="lazy">
                <img *ngIf="carouselShow == 4" [attr.src]="productService.getProductImage(product.screenshot3, isGroup)" alt="Image of the workshop {{product.name}}" title="{{product.name}}" loading="lazy">
            </div>

            <div class="row mb-5 carousel-choices">
                <div class="col carousel-col" *ngIf="product['video']">
                    <div class="carousel-choice" [ngClass]="{'cc-active' : carouselShow == 0}"  (click)="carouselShow = 0" [ngStyle]="{'background-image' : 'url(https://img.youtube.com/vi/'+product['yt_id']+'/mqdefault.jpg)'}"></div>
                </div>
                <div class="col carousel-col">
                    <div class="carousel-choice" [ngClass]="{'cc-active' : carouselShow == 1}"  (click)="carouselShow = 1" [ngStyle]="{'background-image' : 'url('+productService.getProductImage(product.preview, isGroup)+')'}"></div>
                </div>
                <div class="col carousel-col">
                    <div class="carousel-choice" [ngClass]="{'cc-active' : carouselShow == 2}"  (click)="carouselShow = 2" [ngStyle]="{'background-image' : 'url('+productService.getProductImage(product.screenshot1, isGroup)+')'}"></div>
                </div>
                <div class="col carousel-col">
                    <div class="carousel-choice" [ngClass]="{'cc-active' : carouselShow == 3}"  (click)="carouselShow = 3" [ngStyle]="{'background-image' : 'url('+productService.getProductImage(product.screenshot2, isGroup)+')'}"></div>
                </div>
                <div class="col carousel-col">
                    <div class="carousel-choice" [ngClass]="{'cc-active' : carouselShow == 4}"  (click)="carouselShow = 4" [ngStyle]="{'background-image' : 'url('+productService.getProductImage(product.screenshot3, isGroup)+')'}"></div>
                </div>
            </div>

            <div class="readme" [innerHTML]="product.content" *ngIf="product.content && !product.content.includes('.html')">
            </div>
        </div>

        <div class="col-lg-4">
            <div class="mb-4 date-dispo text-center" *ngIf="product.level && product.level != 'Disponible'">
                <span *ngIf="product.level != 'En projet' && product.level != 'Bientôt disponible' ">
                    {{'Disponible en' | translate}}
                    {{months[product.level.slice(0,2)]}}
                    {{product.level.slice(-4)}}
                </span>
                <span *ngIf="product.level == 'En projet' || product.level == 'Bientôt disponible' ">
                    {{product.level | translate}}
                </span>
            </div>

            <div *ngIf="product && product.level && product.level == 'Disponible'">

                <div>
                    <div class="bloc-tarif bg-light">
                        <h2 class="mb-3"><b>{{'Commandez cet exercice' | translate}}</b></h2>
                        <p class="mb-3">{{'Play learn and improve your EHS knowledge.' | translate}}</p>
                        <button class="btn btn-action btn-free-access d-flex py-2 px-3 text-white rounded-pill" [routerLink]="language.navigateAccordingToLang(['/subscription'])" title="subscribe">
                            <b>{{'Commander_' | translate}}</b>
                        </button>
                    </div>
                </div>



            </div>
            <contact-us-btn text="En savoir plus" paddings='px-4 pt-0'></contact-us-btn>
        </div>
    </div>

</div>

<section class="safety-day">
    <div class="safety-day-text">
        <h2><span id="fadedText">{{loopTexts[loopTextIndex]}}</span><br>Everyone, Everywhere, Everyday!</h2>
        <div class="safety-day-icon"></div>
    </div>
</section>

<!-- MODAL -->

<div  class="modal fade" id="modal-interest-success" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header" style="border:none;padding: 8px 15px;">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {{interestMessage}}.
            </div>
            <div class="modal-footer" style="border:none;padding-top: 8px;">
                <button type="button" class="btn btn-primary" onclick="$('#modal-interest-success').modal('hide')">Ok</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modal-interest" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">{{'M’informer de la disponibilité' | translate}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mb-2">
                    <div class="col-12 text-center">
                        {{'ou' | translate}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 text-center left-content">
                        <div class="row col-12 d-inline-block mt-2 mb-2">
                            {{'Renseignez votre adresse email' | translate}}
                        </div>
                        <div class="row col-12 d-inline-block mt-2 mb-2">
                            <input type="email" [(ngModel)]="mail" placeholder="{{'Email' | translate}}" id="emailInput"/>
                        </div>
                        <div class="row col-12 d-inline-block mt-2 mb-2">
                            <button class="btn btn-primary" (click)="sendInterest()" data-dismiss="modal" id="send-interest-button">Ok</button>
                        </div>
                    </div>
                    <div class="col-6 text-center mt-5">
                        <a style="cursor:pointer" class="text-primary row col-12 d-inline-block" onclick="$('#modal-interest').modal('hide')" (click)="appService.showPopup()">
                            {{'Se connecter' | translate}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div  class="modal fade" id="etre-recontacte" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header" style="border:none;padding: 8px 15px;">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {{'Votre demande a été prise en compte, vous allez être recontacté' | translate}}.
            </div>
            <div class="modal-footer" style="border:none;padding-top: 8px;">
                <button type="button" class="btn btn-primary" onclick="$('#etre-recontacte').modal('hide')">Ok</button>
            </div>
        </div>
    </div>
</div>
